import '../../styles/missions.css';
import Missions1 from '../../redux/missions/MissionCreate';

const Missions = () => (
  <div>
    <Missions1 />
  </div>
);

export default Missions;
